import { defineMessages } from 'react-intl';

export const transactionExportMessages = defineMessages({
  fileNameSuffix: {
    id: 'export_transactions.filename_suffix',
    defaultMessage: 'Bank account and transactions',
    description: 'Filename suffix',
  },
});
